import script from "./ArchitectProjectSummaryInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./ArchitectProjectSummaryInfo.vue?vue&type=script&setup=true&lang=js"

import "./ArchitectProjectSummaryInfo.vue?vue&type=style&index=0&id=0bbafa2e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0bbafa2e"]])

export default __exports__